import React from 'react';
import { getResources, deleteResource } from 'utils/ResourcesUtils';
import { useAppContext } from 'hooks/useAppContext';
import SkeletonGrid from 'components/Shared/SkeletonGrid';
import Grid from 'components/Custom/Grid'
import { Resource } from 'classes';

const SettingGrid = () => {
    const { selectedProject } = useAppContext(); //Getting the App Context
    const title = "Resources"
    const getFormPath = () => import('components/Resources/SettingsForm')

    return (
        selectedProject ?
            <Grid
                columns={Resource.columns}
                getRecords={getResources}
                deleteRecord={deleteResource}
                title={title}
                selectedProject={selectedProject}
                component="Resources"
                formPath={getFormPath}
                options={{
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 25]
                }}
                localization={{
                    body: { editRow: { deleteText: "Are you sure you'd like to mark this row as inactive?" } }
                }}
            >
            </Grid> :
            <SkeletonGrid />
    )
}

export default SettingGrid